import { FaYoutube } from 'react-icons/fa';
import React from "react";
import { FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa"; // React Icons
import PropTypes from "prop-types";
import { Link } from "react-router-dom"; // Import Link from react-router-dom
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXTwitter, faMeta  } from "@fortawesome/free-brands-svg-icons";

function Footer() {
  return (
    <div>
      <footer id="footer" className="bg-darkBlue text-gray-300 py-16 px-10 relative">
        <div className="container mx-auto grid grid-cols-1 md:grid-cols-4 gap-5">

          <div >
            <h4 className="text-lg font-bold mb-4 text-white font-cabinet"> <span className="font-bold ">INFREC</span></h4>
            <p className="leading-relaxed font-nunito">
              We provide tailored financial solutions including loans, insurance, and investments to help you secure your future.
            </p>
          </div>

          <div className="md:text-center">
            <h4 className="text-lg font-bold mb-4  font-cabinet text-white">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="hover:text-blue-400 transition font-nunito">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-blue-400 transition font-nunito">
                  About
                </Link>
              </li>
              <li>
                <Link to="/blog" className="hover:text-blue-400 transition font-nunito">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-blue-400 transition font-nunito">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/faqs" className="hover:text-blue-400 transition font-nunito">
                  FAQs
                </Link>
              </li>
              <li>
                <Link to="/careers" className="hover:text-blue-400 transition font-nunito">
                  Careers
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4  font-cabinet text-white">Office Address</h4>
            <ul className="space-y-3 font-nunito">  
              INFREC CONSULTANCY SERVICES (OPC) Pvt Ltd
              <li>Office No. 502, 5th Floor, Beside Timmy Arcade, Jai Antariksh, Makwana Rd, Gamdevi, Marol, Andheri East, Mumbai, Maharashtra 400059</li>
              <li>Email: <a href="mailto:support@finserve.com" className="hover:text-blue-400 transition"> info@infrec.in</a></li>
              <li>Phone: +91 9279123466</li>
            </ul>
          </div>

          <div>
          
            <h4 className="text-lg font-bold mb-4  font-cabinet text-white">Follow Us</h4>
            <div className="flex space-x-4">
              <a href="https://www.instagram.com/infrec.services?igsh=MXhyN3QxMzBmeHRlcA==" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition">
                <FaInstagram size="1.5em" />
              </a>
              <a href="https://www.linkedin.com/company/infrec-consultancy-services-pvt-ltd/?viewAsMember=true" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition">
                <FaLinkedin size="1.5em" />
              </a>
              <a href="https://www.facebook.com/profile.php?id=61573088702649">
                <FaFacebook size="1.5em" />
              </a>
              <a href="https://youtube.com/@infrecconsultancyservices?si=iH8WC4-b7faRbBbr">
                <FaYoutube size="1.5em" />
              </a>
            </div>
          </div>

        </div>

        <div className="mt-12 border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm">
            <p className="text-gray-400 font-nunito">
              &copy; {new Date().getFullYear()} <span className="font-bold text-white font-cabinet text-white">INFREC</span>. All rights reserved.
            </p>

            
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Footer;
